import { render, staticRenderFns } from "./PinterestLinks.vue?vue&type=template&id=d48c9ae2&scoped=true&"
import script from "./PinterestLinks.vue?vue&type=script&lang=js&"
export * from "./PinterestLinks.vue?vue&type=script&lang=js&"
import style0 from "./PinterestLinks.vue?vue&type=style&index=0&id=d48c9ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c9ae2",
  null
  
)

export default component.exports